
export default (urlParameters) => {
  const { platform } = urlParameters

  return {
    ads_allowed: true,
    complete_report_map: true,
    show_widgets: true,
    platform: platform
  }
}